import { render, staticRenderFns } from "./MxLoader.vue?vue&type=template&id=be89cb58"
import script from "./MxLoader.vue?vue&type=script&lang=ts"
export * from "./MxLoader.vue?vue&type=script&lang=ts"
import style0 from "./MxLoader.vue?vue&type=style&index=0&id=be89cb58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports